import { atom } from "recoil";

export const showBannerState = atom({
    key: 'showBanner',
    default: true
})